module.exports = __webpack_public_path__ + "static/media/34DSS5.265d2531.jpg";